<script setup>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import wahaApi from './api';

const store = useStore();
const reconciled = new Set();

const inboxes = computed(() => store.getters['inboxes/getInboxes'] || []);

const patchConnection = (id, waha) => {
  store.dispatch('inboxes/updateWahaConnection', {
    id,
    waha,
    reauthorizationRequired: !waha?.connected,
  });
};

const reconcileInbox = async inbox => {
  if (!inbox?.id || !inbox.waha || reconciled.has(inbox.id)) return;

  reconciled.add(inbox.id);
  try {
    const { data } = await wahaApi.sessionStatus(inbox.id);
    patchConnection(inbox.id, data.waha || {});
  } catch {
    reconciled.delete(inbox.id);
  }
};

watch(
  inboxes,
  list => {
    list.filter(inbox => inbox?.waha).forEach(inbox => {
      reconcileInbox(inbox);
    });
  },
  { immediate: true }
);
</script>

<template>
  <span class="hidden" />
</template>
